// extracted by mini-css-extract-plugin
export default {"root":"UuQfWc","themeGrey":"aqeD_k","skeleton-keyframes-wave":"gaFu2K","themeWhite":"rVwrlu","typeText":"ytyBac","typeCircle":"kNNP4K","typeSquare":"l9WFgX","typeRect":"zW4nua"};